import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
declare var $:any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  routes:{name:string,route:string}[]=[
    {
      name:'Home',
      route:'/'
    },
    {
      name:'Mandatory Public Disclosure',
      route:'/Mandatory-Public-Disclosure'
    },
    {
      name:'Mission & Vision',
      route:'/about-us/vision'
    },
    {
      name:`Principal's Message`,
      route:'/about-us/principal'
    },
    {
      name:'Admission Precedure',
      route:'/admission/process'
    },
    {
      name:'Entrance Test Syllabus',
      route:'/admission/entrance-syllabus'
    },
    {
      name:'Awards & Scholarships',
      route:'/achievements/awards'
    },
    {
      name:'Library & eBooks',
      route:'/admission/library'
    },
    {
      name:'School Hour',
      route:'/admission/hours'
    },
    {
      name:'School Houses',
      route:'/admission/houses'
    },
    {
      name:'School Uniform',
      route:'/admission/uniform'
    },
    {
      name:'Fee Structure',
      route:'/admission/fee'
    },
    {
      name:'Entrance Test Result',
      route:'/admission/entrance-result'
    },
    {
      name:'CBSE Result',
      route:'/achievements/cbse'
    },
    {
      name:'Exemplary Performance',
      route:'/achievements/exemplary'
    },
    {
      name:'Co Scholastic',
      route:'/accomplishment/co'
    },
    {
      name:'Games & Sports',
      route:'/accomplishment/games'
    },
    {
      name:'Cultural',
      route:'/accomplishment/cultural'
    },
    {
      name:'Labs Overview',
      route:'/labs/overview'
    },
    {
      name:'Physics Lab',
      route:'/labs/physics'
    },
    {
      name:'Chemistry Lab',
      route:'/labs/chemistry'
    },
    {
      name:'Biology Lab',
      route:'/labs/biology'
    },
    {
      name:'Self Management',
      route:'/labs/self-management'
    },
    {
      name:'Computer Lab',
      route:'/labs/computer'
    },
    {
      name:'Art & Craft',
      route:'/labs/fine'
    },
    {
      name:'Mathematics',
      route:'/labs/math'
    },
    {
      name:'Administrative Block',
      route:'/campus/administrative'
    },
    {
      name:'Academic Block',
      route:'/campus/academic'
    },
    {
      name:'Music & Art',
      route:'/campus/music'
    },
    {
      name:'Ground ',
      route:'/campus/ground'
    },
    {
      name:'Transport',
      route:'/campus/transport'
    },
    {
      name:'Infrastructure Type',
      route:'/campus/infrastructure'
    },{
      name:'School magazine',
      route:'/glimpses/magazine'
    },
    {
      name:'MPPS Speaks',
      route:'/'
    },
    {
      name:'Blogs',
      route:'/'
    },
    {
      name:'Contact Us',
      route:'/contact-us'
    },
    // {
    //   name:'',
    //   route:''
    // },
    // {
    //   name:'',
    //   route:''
    // },
    // {
    //   name:'',
    //   route:''
    // },
    // {
    //   name:'',
    //   route:''
    // },
    // {
    //   name:'',
    //   route:''
    // },
    // {
    //   name:'',
    //   route:''
    // },

    
  ];
  options = ['option1', 'option2', 'option3'];
searchedOptions = [];

onSeachDropdownValue($event) {
 const value = $event.target.value;
 this.searchedOptions = this.routes.filter(option => option.name.toLowerCase().includes(value.toLowerCase()));
}

onSelectDropdownValue(option) {
  this.router.navigate([option.route])
}
  constructor(private router:Router) { }

  ngOnInit(): void {
    this.clickAnywhere();
  }
  onSubmit(form:NgForm){
    if(!form.valid){
      return;
    }
    let name =form.value.name;
    let phone=form.value.phone;
    let email=form.value.email;
    let message=form.value.message;
   
   
  }
  clickAnywhere(){
    // $('.offcanvas-backdrop').click(function(){
    //   this.showMenuBar();
    // })
  document.addEventListener('click',()=>{
    if($('.offcanvas-backdrop').hasClass('show')){
      this.showMenuBar();
    }
  })
  }
  login(id:number){
    if(id===1){
      window.open('http://maa.eskoool.com/studentlogin.aspx');
    }
    if(id===2){
      window.open('http://maa.eskoool.com');
    }
    if(id===4){
      window.open('https://okiedokiepay.com/#!/60422a95bc40904eb6656898/entityLandingPage');
    }
    if(id===5){
      window.open('https://drive.google.com/file/d/1oWTlnKzAlCRWp5uAkZJmLJ9ZkWy9BB9f/view?usp=sharing');
    }
    if(id===6){
      window.open('https://zfrmz.com/N78EX6RHmJU27lEAyAQz');
    }
  }
  scrollTo(){
    document.getElementById('').scrollIntoView();

  }
  hideMenuBar(){
    $('#menu-bar').hide();
  }
  showMenuBar(){
    $('#menu-bar').show();
    this.searchedOptions=[]
  }
  openModal(){
    
    this.showMenuBar()
    $('#myModal').modal('show');
  }

  openUrl(id:string){
    this.showMenuBar();
    window.open(id);
  }
}
